import React, { Component } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { lighten, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { GetUsers, DeleteUser, GetUser } from '../../fetchs';
import { Link } from 'react-router-dom';
import { Button, Grid } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import AlertDialog from '../Prompt/alert-dialog.component';
import CircularProgress from '@material-ui/core/CircularProgress';

import './user-list.styles.css';
// import Checkbox from '@material-ui/core/Checkbox';
// import IconButton from '@material-ui/core/IconButton';
// import Tooltip from '@material-ui/core/Tooltip';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
// import FilterListIcon from '@material-ui/icons/FilterList';

const headCells = [
  { id: 'pic', numeric: false, disablePadding: true, label: 'عکس' },
  { id: 'firstName', numeric: false, disablePadding: true, label: 'نام' },
  { id: 'lastName', numeric: true, disablePadding: false, label: 'نام خانوادگی' },
  { id: 'phoneNumber', numeric: true, disablePadding: false, label: 'شماره تماس' },
  { id: 'email', numeric: true, disablePadding: false, label: 'رایانامه' },
  // { id: 'isActive', number: true, disablePadding: false, label: 'فعال' },
  { id: 'tools', numeric: false, disablePadding: true, label: '' }
];

const EnhancedTableHead = () => {
  //const { classes } = props;

  return (
    <TableHead>
      <TableRow>
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={'center'}
            padding={headCell.disablePadding ? 'none' : 'default'}
          >
            <TableSortLabel
              active={false}
            >
              {headCell.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
};

const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === 'light'
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  spacer: {
    flex: '1 1 100%',
  },
  actions: {
    color: theme.palette.text.secondary,
    width: '470px'
  },
  title: {
    flex: '0 0 auto',
  },
  formControl: {
    width: '150px'
  },
  link: {
    margin: '10px',
    lineHeight: '4'
  }
}));

const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <Grid item xs={10}>
        {(
          <Typography variant="h6" id="tableTitle">
            لیست کاربران
          </Typography>
        )}
      </Grid>
      <Grid item xs={2}>
        <Link to="/main/user" className={classes.link}>
          <Button variant="contained" color="primary">ساخت کاربر جدید</Button>
        </Link>
      </Grid>
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

export default class UserList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 0,
      rowsPerPage: 20,
      rowsLength: 0,
      visitorId: null,
      visitor: null,
      rows: [],
      alertDialog: false,
      deleteId: null,
      loading: false,
    }
  }

  componentDidMount() {
    if(this.props.match.params.visitorId) {
      this.setState({ visitorId: this.props.match.params.visitorId }, () => {
        this.getVisitorCustomers();
      });
    } else {
      this.getUsersFromServer();
    }
  }

  getUsersFromServer = () => {
    this.setState({loading: true});
    GetUsers(this.state.page * this.state.rowsPerPage, this.state.rowsPerPage)
    .then(response => {
      this.setState({loading: false});
      return response.json();
    })
    .then(responseJson => {
      this.setState({rows: responseJson.data, rowsLength: responseJson.count});
    })
    .catch(error => {
      this.setState({loading: false});
      console.log(error);
    });
  }

  getVisitorCustomers = () => {
    this.setState({loading: true});
    GetUser(this.state.visitorId)
        .then(response => {
          return response.json();
        }).then(responseJson => {
          this.setState({
            visitor: responseJson
          });
        }).catch(error => {
          console.error(error);
        })
  }

  handleChange = (e) => {
    this.setState({ userType: e.target.value }, () => {
      this.getUsersFromServer();
    });
  }

  handleChangePage = (event, newPage) => {
    this.setState({page: newPage}, () => {
      this.getUsersFromServer();
    });
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({rowsPerPage: +event.target.value, page: 0}, () => {
      this.getUsersFromServer();
    });
  }

  handleDelete = () => {
    this.setState({alertDialog: false, loading: true});
    DeleteUser(this.state.deleteId)
      .then(response => {
        this.setState({loading: false});
        if(response.status === 200)
          this.getUsersFromServer();
        
        return response.json();
      })
      .then(responseJson => {
        if(responseJson === "An error occurred while updating the entries. See the inner exception for details."){
          alert("به دلیل استفاده در جای دیگر امکان حذف وجود ندارد");
        }
        console.log(responseJson);
      })
      .catch(error => {
        console.log(error);
      })
  }

  handlePrepareDelete = (id) => {
    this.setState({deleteId: id, alertDialog: true});
  }

  handleCloseDialog = () => {
    this.setState({alertDialog: false});
  }

  emptyRows = () => this.state.rowsPerPage - Math.min(this.state.rowsPerPage, this.state.rowsLength - this.state.page * this.state.rowsPerPage);

  render(){
    const { classes } = this.props;
    return (
      <div className="root">
        <Paper className="paper">
          <EnhancedTableToolbar numSelected={0} />
          <div className="tableWrapper">
            <Table
              className="table"
              aria-labelledby="tableTitle"
              size={'medium'}
            >
              <EnhancedTableHead
                classes={classes}
                numSelected={0}
                rowCount={this.state.rowsLength}
              />
              <TableBody>
                {this.state.rows.map((row, index) => {
                    return (
                      <TableRow
                        hover
                        tabIndex={-1}
                        key={row.name}
                      >
                        <TableCell align="center"><img alt="" src={row.pic} /></TableCell>
                        <TableCell align="center">{row.firstName}</TableCell>
                        <TableCell align="center">{row.lastName}</TableCell>
                        <TableCell align="center">{row.phoneNumber}</TableCell>
                        <TableCell align="center">{row.email}</TableCell>
                        {/* <TableCell align="center">{row.isActive ? <CheckCircleOutlineIcon  style={{ color: "green" }} /> : <HighlightOffIcon style={{ color: "red" }} />}</TableCell> */}
                        <TableCell align="center">
                          <Link to={`/main/user/${row.userId}`}>
                            <EditIcon color="primary" />
                          </Link>
                          <DeleteIcon 
                            className="deleteIcon" 
                            onClick={() => this.handlePrepareDelete(row.userId)} />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                {this.emptyRows > 0 && (
                  <TableRow style={{ height: 49 * this.emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>
          {this.state.loading && <CircularProgress size={24} className="buttonProgress" />}
          <TablePagination
            rowsPerPageOptions={[10, 20, 50]}
            component="div"
            count={this.state.rowsLength}
            rowsPerPage={this.state.rowsPerPage}
            page={this.state.page}
            backIconButtonProps={{
              'aria-label': 'previous page',
            }}
            nextIconButtonProps={{
              'aria-label': 'next page',
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </Paper>
        <AlertDialog 
          open={this.state.alertDialog} 
          title={`اخطار`}
          body={`آیا از حذف کاربر اطمینان دارید؟`} 
          handleYes={this.handleDelete}
          handleNo={this.handleCloseDialog} />
      </div>
    )
  };
}